/**
 * @generated SignedSource<<5ace8f576a15d60a82648327d090e144>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueViewerViewer$data = {
  readonly enterpriseManagedEnterpriseId: string | null | undefined;
  readonly isEnterpriseManagedUser: boolean | null | undefined;
  readonly login: string;
  readonly " $fragmentSpreads": FragmentRefs<"AssigneesSectionViewer" | "IssueCommentComposerViewer">;
  readonly " $fragmentType": "IssueViewerViewer";
};
export type IssueViewerViewer$key = {
  readonly " $data"?: IssueViewerViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueViewerViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueViewerViewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEnterpriseManagedUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enterpriseManagedEnterpriseId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "login",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IssueCommentComposerViewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AssigneesSectionViewer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "50782e9d3bbfe8dd1726ec639ad06b5b";

export default node;
